import { Google } from '../analytics/index.js';
import { getBrandUnit } from '../utilities/index.js';
import { inventoryTransformer as googleInventoryTransformer } from '../transformers/google/index.js';
const onClickEvent = (cmp, eventResult) => function (_temp, option) {
  let {
    data = {},
    state = {},
    dataLayer = {}
  } = _temp === void 0 ? {} : _temp;
  let parsedSearchString;
  if (data.search) {
    parsedSearchString = typeof data.search === 'string' ? JSON.parse(data.search) : data.search;
  }
  const eventData = {
    vehicle: data.vehicle ? googleInventoryTransformer(data.vehicle, {
      target: 'vehicle',
      dataLayer
    }) : undefined,
    search: parsedSearchString ? googleInventoryTransformer(parsedSearchString, {
      target: 'search',
      dataLayer
    }) : undefined,
    consumerInsights: data.consumerInsights || undefined
  };
  // Clean up undefined Object attributes
  Object.keys(eventData).forEach(k => eventData[k] === undefined && delete eventData[k]);
  const {
    brand = ''
  } = state;
  if (eventResult || data.eventResult) {
    Google.sendClickEvent({
      eventElement: getBrandUnit(brand),
      eventResult: data.eventResult || eventResult,
      eventData
    }, option);
  }
  return {
    cmp
  };
};

/**
 * @summary Sends Adobe event when email subscribe button is clicked
 * @cmp subscr_srch
 * @events event1
 */
export const emailSubscribeClick = onClickEvent('subscr_srch');

/**
 * @summary Sends Adobe event when sign in button is clicked
 * @cmp edt_srch
 * @events event1
 */
export const emailSubscribeSignIn = onClickEvent('my_in');

/**
 * @summary Sends Adobe event when Facebook sign in button is clicked
 * @cmp edt_srch
 * @events event1
 */
export const facebookSubscribeSignIn = onClickEvent('my_fcb');

/**
 * @summary Sends Adobe event when messages button is clicked in header
 * @cmp msg_pvt_slr_lnk
 * @events event1
 */
export const messagesHeaderLinkClick = onClickEvent('msg_pvt_slr_lnk');

/**
 * @summary Sends Adobe event when saveChanges button is clicked
 * @cmp save_chg
 * @events event1
 */
export const saveSearchSuccess = onClickEvent('my_st', 'save::search');

/**
 * @summary Sends Adobe event when searchFrequency button is clicked
 * @cmp alt_freq
 * @events event1
 */
export const searchFrequencyClick = onClickEvent('alt_freq');

/**
 * @summary Sends Adobe event when unsubscribe button is clicked
 * @cmp sve-prfrncs-btn
 * @events event1
 */
export const unsubscribeClick = onClickEvent('sve-prfrncs-btn', 'checkbox::unsubscribe::all');

/**
 * @summary Sends Google event and Pixall event when a email/text checkbox or save button for car alerts is clicked
 * @events event1
 */
export const carAlertsClick = onClickEvent('car_alerts');

/**
 * @summary Sends Google event when user clicks on a link to sign in with sell your car ID
 * @events event1
 */
export const sycSignInClick = onClickEvent(null, 'cta::login::ad');
/**
 * @summary Sends Google event when user clicks on a link to sign in
 * @events event1
 */
export const signInCtaClick = onClickEvent(null, 'cta::sign-in');
/**
 * @summary Sends Google event when user clicks on a link to sign up
 * @events event1
 */
export const signUpCtaClick = onClickEvent(null, 'cta::register-start');
export default {
  carAlertsClick,
  emailSubscribeClick,
  emailSubscribeSignIn,
  facebookSubscribeSignIn,
  messagesHeaderLinkClick,
  saveSearchSuccess,
  searchFrequencyClick,
  signInCtaClick,
  signUpCtaClick,
  sycSignInClick
};